module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    class: ['textblock', _vm.cssClasses]
  }, [(_vm.data.title) ? _c('h2', [_vm._v(_vm._s(_vm.data.title))]) : _vm._e(), _vm._v(" "), (_vm.data.subtitle) ? _c('h3', [_vm._v(_vm._s(_vm.data.subtitle))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.body), function(paragraph, key) {
    return (_vm.data.body) ? _c('p', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.data.list && !_vm.data.listType) ? _c('ul', _vm._l((_vm.data.list), function(listItem, key) {
    return _c('li', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(listItem)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.data.list && _vm.data.listType) ? _c('ol', {
    style: ({
      'list-style-type': _vm.data.listType
    })
  }, _vm._l((_vm.data.list), function(listItem, key) {
    return _c('li', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(listItem)
      }
    })
  }), 0) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4cd280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockText.vue
// module id = 655
// module chunks = 0